import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApi } from '../../laas/base-api.service';
import { map } from 'rxjs/operators';

@Injectable()
export class ViewSanctionService {

  adminId: string;
  baseUrl: string;
  private applicantId: string;
  public isRetail: boolean;
  array: any[];

  constructor(
    private api: BaseApi,
  ) {
    // this.applicantId = this.getApplicantID();
    this.adminId = sessionStorage.getItem('wl-admin-id');
    this.baseUrl = `/applicants/${this.applicantId}`;

  }

  getRoleId() {
    return sessionStorage.getItem('getroleId');
  }


  getUsers(input, roleId, offset, limit) {
    let filterDate = sessionStorage.getItem('filterDateDashboard') ? sessionStorage.getItem('filterDateDashboard') : '';
    let dataObj = {
      "adminId": this.adminId,
      "roleId": this.getRoleId(),
      "filter": input,
      "offset": offset,
      "limit": limit,
      "data_type": "loan_sanctioned_ntb",
      "branch_code": sessionStorage.getItem('branch_code'),
      "ro_code": sessionStorage.getItem('ro_code'),
      "zonal_code": sessionStorage.getItem('zonal_code')
    }
    if (filterDate) {
      let date = new Date(filterDate);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }

    let state = sessionStorage.getItem('stateCode');

    console.log('userState------->', state);

    // if(state =="MADHYAPRADESH" || state == "MP"){
    console.log('----------------------');
    return this.api.postResUserSearch('/v1/applicants/userSearch', dataObj).pipe(map(resp => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }))
    // } else {
    //   console.log('-----------else-----------');
    //   return this.api.postRes('/users/userSearch', dataObj).map(resp => {
    //     // console.log("userSearch resp in service " + JSON.stringify(resp));
    //     if(resp && resp.result && resp.result.resultData){
    //       return resp;
    //     }


    //   })
    // }


  }


  getUsersFilterDate(input, roleId, offset, limit, filterDate, endDateInMs, dateType) {

    let dataObj = {
      "adminId": this.adminId,
      "roleId": this.getRoleId(),
      "filter": input,
      "offset": offset,
      "limit": limit,
      "data_type": "loan_sanctioned_ntb",
      "filter_date": filterDate,
      "end_date": endDateInMs,
      "date_type": dateType,
      "branch_code": sessionStorage.getItem('branch_code'),
      "ro_code": sessionStorage.getItem('ro_code'),
      "zonal_code": sessionStorage.getItem('zonal_code')
    }
    let filterDate1 = sessionStorage.getItem('filterDateSanction') ? sessionStorage.getItem('filterDateSanction') : '';
    if (filterDate1) {
      let date = new Date(filterDate1);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }
    // return this.api.postRes('/users/userSearch', dataObj).map(resp => {
    //   // console.log("userSearch resp in service " + JSON.stringify(resp));
    //   return resp;
    // })

    let state = sessionStorage.getItem('stateCode');
    console.log('userState------->', state);

    if (state == "MADHYAPRADESH" || state == "MP") {
      return this.api.postResUserSearch('/v1/applicants/userSearch', dataObj).pipe(map(resp => {
        // console.log("userSearch resp in service " + JSON.stringify(resp));
        if (resp && resp.result && resp.result.resultData) {
          return resp;
        }


      }))
    } else {
      return this.api.postRes('/users/userSearch', dataObj).pipe(map(resp => {
        // console.log("userSearch resp in service " + JSON.stringify(resp));
        if (resp && resp.result && resp.result.resultData) {
          return resp;
        }


      }))
    }
  }


}